import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

type InputProps = InputHTMLAttributes<HTMLInputElement> & { label?: string; error?: string };

export const TextInput = forwardRef<HTMLInputElement, InputProps>(function TextInput(
  { label, error, className, id, ...props },
  ref,
) {
  return (
    <label className="block w-full" htmlFor={id}>
      {label && <span className="mb-1.5 block text-sm font-medium text-tg-text">{label}</span>}
      <input
        ref={ref}
        id={id}
        className={cn(
          'w-full rounded-input border bg-[var(--color-input-bg)] px-3 py-3 text-base text-tg-text shadow-sm outline-none transition placeholder:text-tg-hint focus:border-brand-green focus:bg-tg-bg-secondary focus:ring-2 focus:ring-brand-green/20',
          error ? 'border-destructive' : 'border-[var(--color-input-border)]',
          className,
        )}
        {...props}
      />
      {error && <span className="mt-1 block text-xs text-destructive">{error}</span>}
    </label>
  );
});

type TAProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { label?: string; error?: string };

export const TextArea = forwardRef<HTMLTextAreaElement, TAProps>(function TextArea(
  { label, error, className, id, ...props },
  ref,
) {
  return (
    <label className="block w-full" htmlFor={id}>
      {label && <span className="mb-1.5 block text-sm font-medium text-tg-text">{label}</span>}
      <textarea
        ref={ref}
        id={id}
        rows={3}
        className={cn(
          'w-full rounded-input border bg-[var(--color-input-bg)] px-3 py-3 text-base text-tg-text shadow-sm outline-none transition placeholder:text-tg-hint focus:border-brand-green focus:bg-tg-bg-secondary focus:ring-2 focus:ring-brand-green/20',
          error ? 'border-destructive' : 'border-[var(--color-input-border)]',
          className,
        )}
        {...props}
      />
      {error && <span className="mt-1 block text-xs text-destructive">{error}</span>}
    </label>
  );
});
